import React, { useEffect, useRef } from 'react';
import { startOfMonth, endOfMonth, getDate, isToday, eachDayOfInterval, } from 'date-fns';
import { useLocalizedWeekdays } from './useLocalizedWeekdays';
import { StyledCalendarGrid, StyledCalendarDayHeader, StyledCalendarDay, StyledTodayText, } from './Calendar.styles';
const noop = () => { };
export const CalendarDay = ({ autoFocusSelected, date, disabled, focused, selected, onClick = noop, ...restProps }) => {
    const ref = useRef(null);
    // set standard navigational focus
    useEffect(() => {
        var _a;
        if (ref.current && focused) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focused, ref]);
    // auto-focus when the day is in selected state
    useEffect(() => {
        var _a;
        if (ref.current && selected && autoFocusSelected) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocusSelected, selected, ref]);
    const today = isToday(date);
    const TextWrapper = today ? StyledTodayText : React.Fragment;
    return (React.createElement(StyledCalendarDay, { ...restProps, ref: ref, type: "button", onClick: (...args) => !disabled && onClick(...args), "aria-disabled": disabled, "aria-current": today ? 'date' : undefined, "aria-pressed": selected },
        React.createElement(TextWrapper, null, getDate(date))));
};
export const CalendarWeek = () => {
    const { weekdays } = useLocalizedWeekdays();
    return (React.createElement(StyledCalendarGrid, { weekdays: weekdays }, weekdays.map((weekday) => (React.createElement(StyledCalendarDayHeader, { key: `day-header__${weekday.toLowerCase()}`, weekday: weekday }, weekday)))));
};
export const CalendarMonth = ({ autoFocusSelected, month, getDateProps: dayProps = () => ({}), onClickDate: handleClick = noop, onMouseEnterDate: handleMouseEnter = noop, onKeyPressDate: handleKeyPress = noop, onKeyDownDate: handleKeyDown = noop, onKeyUpDate: handleKeyUp = noop, }) => {
    const { weekdays, getDay } = useLocalizedWeekdays();
    return (React.createElement(StyledCalendarGrid, { weekdays: weekdays }, eachDayOfInterval({
        start: startOfMonth(month),
        end: endOfMonth(month),
    }).map((date) => (React.createElement(CalendarDay, { key: date.toString(), weekday: getDay(date), onClick: (event) => handleClick(date, event), onMouseEnter: (event) => handleMouseEnter(date, event), onKeyPress: (event) => handleKeyPress(date, event), onKeyDown: (event) => handleKeyDown(date, event), onKeyUp: (event) => handleKeyUp(date, event), date: date, autoFocusSelected: autoFocusSelected, ...dayProps(date) })))));
};
//# sourceMappingURL=Calendar.js.map